module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/united-nation-8d5525df14f7258bdc13566b6c42527a.png";